import React, { FC } from 'react';

type CandidateSkillChipsProps = {
  skills: string[];
  variant?: 'saved' | 'new';
};

const CandidateSkillChips: FC<CandidateSkillChipsProps> = ({
  skills,
  variant = 'saved'
}) => {
  if (!skills.length) {
    return null;
  }

  return (
    <div className="cv-skills-review__chips">
      {skills.map((skill) => (
        <span
          key={skill}
          className={`candidate-skill-chip candidate-skill-chip--${variant}`}
        >
          {skill}
        </span>
      ))}
    </div>
  );
};

export default CandidateSkillChips;
